<template>
  <div class="homepage">
    <v-row :class="isMobile ? 'col-reverse' : ''">
      <v-col v-if="!isMobile" cols="12">
        <fruit-slide
          @selectFruitHandler="selectFruitHandler"
          :fruits="fruits"
          :selectedFruit="selectedFruit"
        ></fruit-slide>
      </v-col>
      <v-col cols="12" md="7" class="px-6">
        <div class="homepage__imgs">
          <img :src="require('@/assets/images/map/Main.svg')" alt="" />
          <div :key="imgUpdated">
            <img
              :class="img.selected ? 'img-selected' : ''"
              v-for="(img, i) in imgs"
              :key="i"
              :src="img.img"
            />
          </div>
        </div>
        <div class="text-center mt-8">
          <span class="primary--text font-25" v-if="noImages"
            >لا يوجد بيانات في هذا الشهر لهذا المحصول</span
          >
        </div>
        <fruit-details
          v-if="isMobile"
          :selectedFruit="selectedFruit"
        ></fruit-details>
      </v-col>
      <v-col cols="12" md="5" class="relative">
        <fruit-slide
          @selectFruitHandler="selectFruitHandler"
          v-if="isMobile"
          :fruits="fruits"
          :selectedFruit="selectedFruit"
        ></fruit-slide>
        <div class="homepage__info" :key="monthKey">
          <search-select
            :selectedFruit="selectedFruit"
            @change="dateHandler"
          ></search-select>
          <fruit-details
            v-if="!isMobile"
            :selectedFruit="selectedFruit"
          ></fruit-details>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import data from "../data/data.json";
import SearchSelect from "./components/SearchSelect.vue";
import FruitDetails from "./components/Details.vue";
import FruitSlide from "./components/FruitSlide.vue";
export default {
  components: { SearchSelect, FruitDetails, FruitSlide },
  data: () => ({
    imgs: [
      { img: require("@/assets/images/map/الباحة.svg"), name: "_10" },
      { img: require("@/assets/images/map/الجوف.svg"), name: "_2" },
      { img: require("@/assets/images/map/الحدود الشمالية.svg"), name: "_7" },
      { img: require("@/assets/images/map/الرياض.svg"), name: "_0" },
      { img: require("@/assets/images/map/المدينة المنورة.svg"), name: "_5" },
      { img: require("@/assets/images/map/المنطقة الشرقية.svg"), name: "_6" },
      { img: require("@/assets/images/map/تبوك.svg"), name: "_4" },
      { img: require("@/assets/images/map/جيزان.svg"), name: "_9" },
      { img: require("@/assets/images/map/حائل.svg"), name: "_3" },
      { img: require("@/assets/images/map/عسير.svg"), name: "_8" },
      { img: require("@/assets/images/map/قاسم.svg"), name: "_1" },
      { img: require("@/assets/images/map/مكه.svg"), name: "_11" },
      { img: require("@/assets/images/map/نجران.svg"), name: "_12" },
    ],
    mapImgs: [],
    settings: {
      arrows: true,
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
    },
    data: data,
    selectedFruit: {},
    selectedMap: "",
    monthKey: false,
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    imgUpdated: false,
    noImages: false,
  }),
  computed: {
    fruits() {
      return data;
    },
  },
  methods: {
    selectFruitHandler(fruit) {
      this.mapImgs = [];
      this.selectedFruit = fruit;
      this.monthKey = !this.monthKey;

      const d = new Date();
      this.dateHandler(this.months[d.getMonth()]);
    },
    dateHandler(val) {
      let month = this.selectedFruit.places.filter(
        (month) => month.name == val
      )[0];
      if (month.value.length > 0) {
        this.imgs.forEach((img) => {
          month.value.forEach((fruitMap) => {
            if (fruitMap == img.name) {
              img.selected = true;
            } else {
              img.selected = false;
            }
          });
        });
        this.noImages = false
      } else {
        this.imgs.forEach((img) => {
          img.selected = false;
        });
        this.noImages = true
      }
      this.imgUpdated = !this.imgUpdated;
    },
  },
  created() {
    this.selectedFruit = this.fruits[0];
    const d = new Date();
    this.dateHandler(this.months[d.getMonth()]);
  },
};
</script>

<style lang="scss">
.homepage {
  max-width: 1500px;
  width: 100%;
  margin: auto;
  &__imgs {
    position: relative;
    width: 90%;
    height: 500px;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      opacity: 0.2;
    }
  }
  .img-selected {
    opacity: 1;
  }

  &__fruit {
    height: 130px;
    background-size: contain !important;
    position: relative;
    cursor: pointer;

    &__img {
      height: 130px;
      width: 130px;
      position: absolute;
      object-fit: cover;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      top: -28px;
      z-index: 9999999999999;
    }
    &__shadow {
      position: absolute;
      top: 0px;
      left: 50%;
      width: 144px;
      transform: translateX(-50%);
      transition: 0.3s;
      opacity: 0;
      &--active {
        opacity: 1;
      }
    }
    &:hover & {
      &__shadow {
        opacity: 1;
      }
    }
  }
  &__info {
    max-width: 550px;
    margin: auto;
  }
  @media (max-width: 960px) {
    &__imgs {
      margin: auto;
      height: 370px;
    }
  }
}
.img-title {
  font-size: 40px;
  font-weight: bold;
  color: #29a671;
}

.slick-list {
  overflow: inherit !important;
  padding: 0px !important;
}
// .fruit-slide @selectFruitHandlerr="selectFruitHandler" {
//   position: absolute !important;
//   left: 0px !important;
//   overflow: inherit;
//   overflow-x: clip;
//   width: 100%;
//   z-index: 9999;
// }
// .slick-slide {
//   width: 140px !important;
// }
.slick-prev {
  left: 46%;
  transform: translateX(-50%);
  top: unset;
  bottom: -40px;
  width: 35px;
  height: 35px;
}
.slick-next {
  left: 54%;
  transform: translateX(-50%);
  top: unset;
  bottom: -40px;
  width: 35px;
  height: 35px;
}
</style>
